export const THEMES = {
  padrao: {
    nome: 'Padrão CDI',
    descricao: 'Identidade visual oficial',
    cores: { blue: '#262b5c', yellow: '#FAB700', canvas: '#FAF9F5', carbon: '#0A0A0A' },
  },
  copa_mundo: {
    nome: 'Copa do Mundo',
    descricao: 'Cores da Seleção Brasileira',
    cores: { blue: '#009C3B', yellow: '#FFDF00', canvas: '#FFFFFF', carbon: '#0A0A0A' },
  },
  dia_maes: {
    nome: 'Dia das Mães',
    descricao: 'Tons rosados e acolhedores',
    cores: { blue: '#E91E8C', yellow: '#FFB7D5', canvas: '#FFF5F8', carbon: '#3D1A2B' },
  },
  pascoa: {
    nome: 'Páscoa',
    descricao: 'Tons pastéis e violeta',
    cores: { blue: '#8B5CF6', yellow: '#FBBF24', canvas: '#F5F0FF', carbon: '#2D1B69' },
  },
  natal: {
    nome: 'Natal',
    descricao: 'Vermelho e verde festivos',
    cores: { blue: '#C8102E', yellow: '#0B6E4F', canvas: '#FFF8F0', carbon: '#1A1A1A' },
  },
  personalizado: {
    nome: 'Tema Personalizado',
    descricao: 'Defina as cores da identidade visual',
    cores: { blue: '#262B5C', yellow: '#FAB700', canvas: '#FAF9F5', carbon: '#0A0A0A' },
  },
};

export const DEFAULT_LOGO = '/images/cdi-premium-logo.webp';
export const CUSTOM_THEME_KEY = 'personalizado';
export const COLOR_KEYS = ['blue', 'yellow', 'canvas', 'carbon'];

const HEX_COLOR_PATTERN = /^#[0-9A-F]{6}$/i;

export function isValidHexColor(value) {
  return typeof value === 'string' && HEX_COLOR_PATTERN.test(value);
}

export function normalizeHexColor(value) {
  return isValidHexColor(value) ? value.toUpperCase() : null;
}

export function defaultCustomColors() {
  return { ...THEMES.padrao.cores };
}

/**
 * Returns a complete, safe palette for a stored theme configuration.
 * Each invalid custom value falls back independently to the standard palette.
 */
export function resolveThemeColors(config) {
  const themeKey = config?.tema_ativo;
  if (themeKey !== CUSTOM_THEME_KEY) {
    return { ...(THEMES[themeKey] || THEMES.padrao).cores };
  }

  const savedColors = config?.cores_personalizadas;
  const fallback = defaultCustomColors();
  return COLOR_KEYS.reduce((colors, key) => {
    colors[key] = normalizeHexColor(savedColors?.[key]) || fallback[key];
    return colors;
  }, {});
}

export function buildThemeConfigData({ temaAtivo, customColors, logoUrl, faviconUrl }) {
  return {
    tema_ativo: temaAtivo,
    cores_personalizadas: resolveThemeColors({
      tema_ativo: CUSTOM_THEME_KEY,
      cores_personalizadas: customColors,
    }),
    logo_url: logoUrl,
    favicon_url: faviconUrl,
  };
}

function hexToRgb(hex) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `${r} ${g} ${b}`;
}

export function applyTheme(config) {
  if (!config) return;
  const colors = resolveThemeColors(config);
  const root = document.documentElement;
  root.style.setProperty('--cdi-blue', hexToRgb(colors.blue));
  root.style.setProperty('--cdi-yellow', hexToRgb(colors.yellow));
  root.style.setProperty('--cdi-canvas', hexToRgb(colors.canvas));
  root.style.setProperty('--cdi-carbon', hexToRgb(colors.carbon));

  const themeColor = document.querySelector("meta[name='theme-color']");
  themeColor?.setAttribute('content', colors.blue);

  if (config.favicon_url) {
    for (const link of Array.from(document.querySelectorAll("link[rel~='icon'], link[rel='apple-touch-icon']"))) link.remove();
    const icon = document.createElement('link');
    icon.setAttribute('rel', 'icon');
    icon.setAttribute('href', config.favicon_url);
    document.head.appendChild(icon);
    const appleIcon = document.createElement('link');
    appleIcon.setAttribute('rel', 'apple-touch-icon');
    appleIcon.setAttribute('href', config.favicon_url);
    document.head.appendChild(appleIcon);
  }
}
